import {safelyGetStorageItem} from '@vio/core/src/_web/utils/persistence/safelyGetStorageItem'
import {safelySetStorageItem} from '@vio/core/src/_web/utils/persistence/safelySetStorageItem'

export const FREEZABLE_FILTER_TOOLTIP_STORAGE_KEY = 'dfFilterTooltipShown'

const TRUE_VALUE = '1'

export const readFreezableFilterTooltipShown = (): boolean => {
  const raw = safelyGetStorageItem(
    'localStorage',
    FREEZABLE_FILTER_TOOLTIP_STORAGE_KEY,
    'readFreezableFilterTooltipShown failed'
  )
  return raw === TRUE_VALUE
}

export const markFreezableFilterTooltipShown = (): void => {
  safelySetStorageItem(
    'localStorage',
    FREEZABLE_FILTER_TOOLTIP_STORAGE_KEY,
    TRUE_VALUE,
    'markFreezableFilterTooltipShown failed'
  )
}
